import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Do you really offer a free consultation?",
    a: "Yes — phone or video consultation is free, with no obligation. We'll talk through symptoms, age and model of the equipment, and let you know whether it's worth scheduling an onsite visit. For video, we send a meeting link so you can show us the unit live.",
  },
  {
    q: "How much does a service call cost?",
    a: "Our base service call is $65 — that covers the trip out and the onsite diagnostic. Any actual repair is quoted in writing before any work begins, so there are no surprise charges. Parts and labor are itemized.",
  },
  {
    q: "What areas do you service?",
    a: "We cover Southern Oregon — Medford, Ashland, Grants Pass, Klamath Falls and surrounding communities. If you're nearby, give us a call and we'll see if we can help.",
  },
  {
    q: "Do you work on residential and commercial equipment?",
    a: "Both. Residential HVAC and small commercial systems, full commercial refrigeration (walk-ins, reach-ins, ice machines, prep tables), and commercial cooking lines (ranges, ovens, fryers, char-broilers, steamers).",
  },
  {
    q: "Do you offer emergency or same-day service?",
    a: "We respond to every request the same business day. For down equipment that's costing you product or revenue, calling is the fastest path to getting on the schedule.",
  },
  {
    q: "What brands do you service?",
    a: "All major HVAC, refrigeration, and cooking equipment brands. If you have the make and model handy when you call, that helps us bring the right parts on the first trip.",
  },
  {
    q: "Are you licensed and insured?",
    a: "Yes — fully licensed and insured to operate in Oregon. Documentation is available on request.",
  },
];

export default function FAQ() {
  return (
    <section className="bg-slate-50 border-t border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="text-xs tracking-[0.22em] uppercase font-semibold text-blue-900">
              FAQ
            </div>
            <h2 className="font-display font-black tracking-tighter text-3xl sm:text-4xl lg:text-5xl text-slate-900 mt-4">
              Common questions, straight answers.
            </h2>
            <p className="text-base text-slate-600 mt-5 leading-relaxed">
              Don't see your question here? Call or use the contact form — we'll
              get back to you the same business day.
            </p>
          </div>
          <div className="md:col-span-7">
            <Accordion
              type="single"
              collapsible
              data-testid="faq-accordion"
              className="bg-white border border-slate-200"
            >
              {FAQS.map((f, idx) => (
                <AccordionItem
                  key={idx}
                  value={`faq-${idx}`}
                  data-testid={`faq-item-${idx}`}
                  className="border-b border-slate-200 last:border-b-0 px-6"
                >
                  <AccordionTrigger className="text-left font-display font-semibold text-slate-900 text-base sm:text-lg py-5 hover:no-underline">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-slate-600 leading-relaxed pb-5">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
